import { ReactElement, useMemo, useEffect, useState, useCallback } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { createServerSideHelpers } from '@trpc/react-query/server';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { createAssociatedTokenAccountInstruction, getAssociatedTokenAddressSync } from '@solana/spl-token';
import { Transaction } from '@solana/web3.js';
import { isMetadata, Metadata, Metaplex, PublicKey } from "@metaplex-foundation/js"
import { claimRewards, fetchIdlAccountDataById, findRewardEntryId, RewardEntry, rewardsCenterProgram, stake, unstake } from '@cardinal/rewards-center';
import { toast } from 'react-hot-toast';
import styled, { css } from 'styled-components';

import MainLayout from 'components/layout/mainLayout';
import WalletLayout from 'components/layout/walletLayout';
import MaxWidthWrapper from 'components/layout/maxWidthWrapper';
import WalletButton from 'components/common/wallet/walletButton';
import CollectionSwitch from 'components/staking/collectionSwitch';
import StakingCard from 'components/staking/stakingCard';

import { createContext } from 'server/context';
import superJson from 'utils/superJson';
import { appRouter } from 'server/routers/_app';

import useLayout from 'providers/layout/layoutProvider';
import theme, { bp, color } from 'settings/theme';

import { useRewardDistributorData } from 'hooks/useRewardDistributorData';

type Props = {};

const StakingPage: NextPageExtended<Props> = (props) => {


  const gobiAddress = new PublicKey("MarcoPaG4dV4qit3ZPGPFm4qt4KKNBKvAsm2rPGNF72");

  const layout = useLayout();
  const router = useRouter();
  const wallet = useWallet();
  const { connection } = useConnection();
  // const stakePoolData = useStakePoolData();

  const [collectionFilter, setCollectionFilter] = useState<string>("3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR")
  const [balance, setBalance] = useState(0);
  const [validNFTHeld, setValidNFTHeld] = useState<Nft[]>([]);
  const [status, setStatus] = useState({
    fetchingNfts: false,
    isStaking: false,
    isLoading: false,
  });
  const [stakeEntries, setStakeEntries] = useState<any[]>([] as any[]);
  const [stakedMaps, setStakedMaps] = useState<number>(0);
  const [stakedMerchants, setStakedMerchants] = useState<number>(0);
  // const [mx, setMx] = useState<Metaplex>();
  // Load Data
  const mx = Metaplex.make(connection);


  const stakePoolId = useMemo(() => {
    return collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ?
      new PublicKey("EMcaKcSwm4NbWAZWQheX91kP6P6E5M7wbKHBKe8PhLrQ")
      :
      new PublicKey("6qxBcNGKGsURCwBX83sa42VvRreLv1Bzfgb3nrF79mm1")
  }, [collectionFilter])

  // useEffect(() => {
  //   if (stakePoolData.data) {
  //     console.log("stakedPoolData.data", stakePoolData.data.parsed)
  //   }
  // }, [stakePoolData.data])
  const fetchNFTs = async () => {
    try {
      // TODO - Load NFTs from wallet
      setStatus((x) => ({ ...x, fetchingNfts: true }));
      mx.rpc()
        .getBalance(wallet.publicKey)
        .then((x) => setBalance(x.basisPoints.toNumber() / 10 ** 9))
        .catch((e) => console.error("Error to fetch wallet balance", e));

      // console.log("wallet.publicKey", wallet.publicKey)
      mx.nfts()
        .findAllByOwner({
          owner: wallet.publicKey,
          // owner: new PublicKey("GyXg8F1HdbT149eviu95jaeN8EGXpZtPiGrGkf545PHH"),
          // owner: new PublicKey("E5b57gGNDpiT4jE7qrEDAiHGRswzBfGVPDqZcEjKoB4B"),
        })
        .then(async (x) => {
          // (async () => {
          const validNFTs = x.filter((a) => a.model == "metadata" && (a.collection?.address.toBase58() === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" || a.collection?.address.toBase58() === "FuKxLFz7bC8b9Fuhh8e3F1aJVDEKnuavVEZpbED53s7B") && a.collection.verified);
          // console.log("validNFTs", validNFTs);
          const collectionNFTS = await Promise.all(validNFTs.map(async (nft) => {
            // console.log(nft.address.toBase58(), " | ", nft.name)
            if (isMetadata(nft)) {
              const loadedMetadata = await mx.nfts().load({ metadata: nft })
                .then((loadedMetadata) => loadedMetadata
                )
              const nftObj = {
                name: nft.name,
                imageUrl: loadedMetadata.json?.image,
                collectionAddress: nft.collection?.address.toBase58(),
                mintAddress: nft.mintAddress.toBase58(),
                isSelected: false,
                isCurrentlyStaked: false,
              } as Nft
              // console.log("nftObj", nftObj)
              return nftObj
            }
          }))
          // console.log("collectionNFTS", collectionNFTS)
          // const tempCollectionNFTs = Array(10).fill(collectionNFTS.filter((nft) => nft.collectionAddress === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR")[0])
          // setValidNFTHeld(tempCollectionNFTs)
          setValidNFTHeld(collectionNFTS)
        })
        .catch((e) => console.error("Failed to fetch wallet nft holdings", e))
        .finally(() => setStatus((x) => ({ ...x, fetchingNfts: false })));

      const userId = wallet.publicKey;
      const program = rewardsCenterProgram(connection, wallet)
      // console.log(stakePoolData.data?.pubkey.toString())
      const stakeEntriesForUser = await program.account.stakeEntry.all([
        {
          memcmp: {
            offset: 82,
            bytes: userId.toString(),
          },
        },
      ])
      const stakeEntries = (
        stakeEntriesForUser.map((e) => {
          return {
            pubkey: e.publicKey,
            parsed: e.account,
          }
        })
      ).filter(
        (entry) => entry.parsed?.pool.toString() === "EMcaKcSwm4NbWAZWQheX91kP6P6E5M7wbKHBKe8PhLrQ" || "6qxBcNGKGsURCwBX83sa42VvRreLv1Bzfgb3nrF79mm1"
      )

      const stakedMerchantsCount = stakeEntries.filter((stakeEntry) => stakeEntry.parsed?.pool.toString() === "EMcaKcSwm4NbWAZWQheX91kP6P6E5M7wbKHBKe8PhLrQ").length;
      const stakedMapsCount = stakeEntries.length - stakedMerchantsCount;

      setStakedMaps(stakedMapsCount);
      setStakedMerchants(stakedMerchantsCount);
      // console.log("stakeEntries", JSON.stringify(stakeEntries.map(stakeEntry=>{
      //   return { 
      //     lastStaker: stakeEntry.parsed.lastStaker.toString(),
      //     lastUpdatedAt: stakeEntry.parsed.lastUpdatedAt.toNumber(),
      //     // usedStakedSeconds: stakeEntry.parsed.usedStakeSeconds.toNumber(),
      // }}),null,2))

      // console.log("stakeEntries", stakeEntries)
      // console.log("Total Claimable Rewards", stakeEntries.reduce((acc, entry) => acc + entry.claimableRewards, 0));
      const stakedValidNfts = await mx.nfts().findAllByMintList({
        mints: [...stakeEntries.map((entry) => entry.parsed?.stakeMint)]
      })
        .then(async (nfts) => {
          // console.log("nfts", nfts)
          const stakedNftObjs = await Promise.all(nfts.map(async (nft) => {
            if (isMetadata(nft)) {
              const loadedMetadata = await mx.nfts().load({ metadata: nft })
                .then((loadedMetadata) => loadedMetadata
                )
              const nftObj = {
                name: nft.name,
                imageUrl: loadedMetadata.json?.image,
                collectionAddress: nft.collection?.address.toBase58(),
                mintAddress: nft.mintAddress.toBase58(),
                isSelected: false,
                isCurrentlyStaked: true,
              } as Nft
              // console.log("nftObj", nftObj)
              return nftObj
            }
          }))
          // console.log("stakedNftObjs", stakedNftObjs)
          return stakedNftObjs
        })
      // console.log("stakedValidNfts", stakedValidNfts)

      setStakeEntries(stakeEntries);
      setValidNFTHeld((x) => [...x.map((nft) => {
        const isStaked = stakedValidNfts.find((stakedNft) => stakedNft.mintAddress === nft.mintAddress)
        if (isStaked) {
          return {
            ...nft,
            isCurrentlyStaked: true
          }
        }
        else {
          return {
            ...nft,
            isCurrentlyStaked: false
          }
        }
      })])
    } catch (error) { }

  }

  const rewardRate = useMemo(() => {
    return collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? 4 : 6;
  }, [collectionFilter])

  interface RewardEntryWithRewards extends RewardEntry {
    allTimeRewardsEarned: number;
  }
  const getRewardsEntries = async (stakeEntryIds: PublicKey[], stakePoolId?: PublicKey) => {
    const rewardDistibutorId = new PublicKey(collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "38JuPXo9QpFFnBsvk75a3fScCQSC7f6phtidHpAtQhWr" : "HQw3xmjaPSwNVVPNjstCmj3uFXdpwfzqP9HYqnAqqUdS");
    // const rewardDistibutorData = useRewardDistributorData(stakePoolId);

    // console.log("rewardDistibutorData", rewardDistibutorData)

    const rewardEntryIds = await Promise.all(
      stakeEntryIds.map(async (stakeEntryId: any) =>
        findRewardEntryId(rewardDistibutorId, stakeEntryId)
      )
    )

    const idlData = await fetchIdlAccountDataById(
      connection,
      rewardEntryIds
    )
    const rewardEntryData = Object.values(idlData).reduce(
      (acc, account) => {
        if (account.type === 'rewardEntry') {
          const allTimeRewardsEarned = Math.floor(account.parsed.rewardSecondsReceived.toNumber() / (1 / (rewardRate / 86400)))
          return [...acc, { ...account, allTimeRewardsEarned }]
        }
        return acc
      },
      [] as RewardEntryWithRewards[]
    )
    // console.log("rewardEntryData", rewardEntryData);
    return rewardEntryData

  }

  const [rewardsEntries, setRewardEntries] = useState<RewardEntryWithRewards[]>([]);

  useEffect(() => {
    if (!stakeEntries.length || !stakePoolId) return;
    else {
      (async () => {
        const rewardEntries = await getRewardsEntries(stakeEntries.map((entry) => entry.pubkey), stakePoolId);
        setRewardEntries(rewardEntries);
      })();
    }
  }, [stakeEntries, stakePoolId])

  const getClaimableRewards = (lastUpdatedAtSeconds: number, currentSeconds: number) => {
    const secondsSinceLastUpdate = currentSeconds - lastUpdatedAtSeconds;
    const claimableRewardsIncrements = Math.floor(secondsSinceLastUpdate / (1 / (rewardRate / 86400)))
    return claimableRewardsIncrements;
  }
  const claimableRewards = useMemo(() => {
    if (!stakeEntries.length || !wallet.publicKey) return 0;
    // console.log("Checking stake entries for claimable rewards",stakeEntries);
    const currentSeconds = Math.floor((Date.now() / 1000));
    const validStakeEntries = stakeEntries
      .filter((stakeEntry) => stakeEntry.parsed?.pool.equals(stakePoolId))
      .map((stakeEntry) => {
        const claimableRewards = getClaimableRewards(stakeEntry.parsed?.lastUpdatedAt.toNumber(), currentSeconds);
        return {
          ...stakeEntry,
          claimableRewards
        }
      })
    // console.log("validStakeEntries", validStakeEntries)
    const totalClaimableRewards = validStakeEntries.reduce((acc, entry) => acc + entry.claimableRewards, 0);

    // console.log("claimableRewards", totalClaimableRewards)
    return totalClaimableRewards;
  }, [stakeEntries, rewardRate, wallet.publicKey])


  const totalAccumulatedRewards = useMemo(() => {
    const totalAccumulatedRewards = rewardsEntries.reduce((acc, entry) => acc + entry.allTimeRewardsEarned, 0);
    // console.log("totalAccumulatedRewards", totalAccumulatedRewards)
    return totalAccumulatedRewards;
    // return rewardEntries.reduce((acc, entry) => acc + entry.allTimeRewardsEarned, 0);
  }, [rewardsEntries]);


  // On Wallet Change
  useEffect(() => {
    setStakedMerchants(0);
    setStakedMaps(0);
    if (!wallet.publicKey) {
      setValidNFTHeld([] as Nft[]);
      return;
    }
    else {
      // console.log("wallet.publicKey", wallet.publicKey)
      fetchNFTs()
    }
  }, [wallet.publicKey]);

  // On Collection Change
  useEffect(() => {
    if (router.query?.collection == "maps") {
      setCollectionFilter("FuKxLFz7bC8b9Fuhh8e3F1aJVDEKnuavVEZpbED53s7B")
    }
    else {
      setCollectionFilter("3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR");
    }
  }, [router.query?.collection]);

  // Stake All
  const handleStake = async () => {
    if (!wallet.publicKey) {
      toast.error(`Please connect your wallet`, {
        id: "stake",
        duration: 5000
      })
      return;
    }
    try {
      const selectedCollectionNFTs = validNFTHeld.filter((nft) => nft.collectionAddress === collectionFilter && nft.isSelected && !nft.isCurrentlyStaked);
      const selectedNFTs = (selectedCollectionNFTs.length > 0 ? selectedCollectionNFTs : validNFTHeld.filter((nft) => nft.collectionAddress === collectionFilter)).map((nft) => {
        return {
          ...nft,
          isSelected: true
        }
      });
      toast.loading("Generating Stake Transactions", {
        id: "stake",
        duration: Infinity
      })
      // console.log("selectedNFTs", selectedNFTs)

      const stakePoolEntries = selectedNFTs.map((nft) => {
        return {
          mintId: new PublicKey(nft.mintAddress)
        }
      });

      let stakeSelected = await stake(
        connection,
        wallet,
        collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "pool-name-0.1908876937934032" : "pool-name-0.7364440881038641",
        stakePoolEntries
      )
      // console.log("stakeSelected", stakeSelected)


      const { blockhash } = await connection.getLatestBlockhash();
      const datedStakeSelected = stakeSelected.map((tx) => {
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        return tx;
      }
      );

      const signedTransactions = await wallet.signAllTransactions(datedStakeSelected);

      await Promise.all(
        (signedTransactions as Transaction[])
          .map((tx) =>
            connection.sendRawTransaction(tx.serialize(), {
              // skipPreflight: false,
              preflightCommitment: "confirmed",
            })
              .then(async (txid) => {
                toast.loading("Attempting to Stake NFTs",
                  {
                    id: "stake",
                    duration: Infinity
                  }
                )
                // console.log("txid", txid)
                await connection.confirmTransaction(txid, "confirmed")
                toast.success("Successfully Staked NFTs",
                  {
                    id: "stake",
                    duration: 5000
                  }
                )
                fetchNFTs();
                // setValidNFTHeld([...validNFTHeld, ...selectedNFTs])
              })
          ));

      // console.log("stakeTxs", stakeTxs)
    } catch (error) {
      let errorMessage = error?.message ?? error;
      // console.error("Error staking nft", errorMessage)
      toast.error(`Error staking nft ${errorMessage}`, {
        id: "stake",
        duration: 5000
      })
    }

  };

  // Unstake All
  const handleUnstake = async () => {

    if (!wallet.publicKey) {
      toast.error(`Please connect your wallet`, {
        id: "unstake",
        duration: 5000
      })
      return;
    }
    try {
      const selectedCollectionNFTs = validNFTHeld.filter((nft) => nft.collectionAddress === collectionFilter && nft.isSelected && nft.isCurrentlyStaked);
      const selectedNFTs = (selectedCollectionNFTs.length > 0 ? selectedCollectionNFTs : validNFTHeld.filter((nft) => nft.collectionAddress === collectionFilter)).map((nft) => {
        return {
          ...nft,
          isSelected: false
        }
      });
      toast.loading("Generating Unstake Transactions", {
        id: "unstake",
        duration: Infinity
      })
      // console.log("selectedNFTs", selectedNFTs)

      const unstakePoolEntries = selectedNFTs.map((nft) => {
        return {
          mintId: new PublicKey(nft.mintAddress)
        }
      });

      let unstakeSelected = await unstake(
        connection,
        wallet,
        collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "pool-name-0.1908876937934032" : "pool-name-0.7364440881038641",
        unstakePoolEntries,
        [new PublicKey(collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "38JuPXo9QpFFnBsvk75a3fScCQSC7f6phtidHpAtQhWr" : "HQw3xmjaPSwNVVPNjstCmj3uFXdpwfzqP9HYqnAqqUdS")],
      )


      // const unstakePoolEntries = await Promise.all(selectedNFTs.map(async (nft) => {
      //   const unstakeEntry = await unstake(
      //     connection,
      //     wallet,
      //     {
      //       stakePoolId: new PublicKey("EMcaKcSwm4NbWAZWQheX91kP6P6E5M7wbKHBKe8PhLrQ"),
      //       originalMintId: new PublicKey(nft.mintAddress),
      //     }
      //   )
      //   return unstakeEntry
      // }));

      const { blockhash } = await connection.getLatestBlockhash();
      const datedUnstakeSelected = unstakeSelected.map((tx) => {
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        return tx;
      });

      const userGobiATA = getAssociatedTokenAddressSync(gobiAddress, wallet.publicKey);
      // console.log("userGobiATA", userGobiATA)
      let isGobiATAOpen = (await connection.getAccountInfo(userGobiATA)) !== null;

      if (!isGobiATAOpen) {
        let createGobiATA = createAssociatedTokenAccountInstruction(
          wallet.publicKey,
          userGobiATA,
          wallet.publicKey,
          gobiAddress,
        )

        const { blockhash } = await connection.getLatestBlockhash();

        const tx = new Transaction().add(createGobiATA);
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        toast.loading("Step 1 of 2: Please create your rewards token account first", {
          id: "unstake",
          duration: Infinity
        })
        await wallet.sendTransaction(tx, connection)
        toast.success("Step 2 of 2: Successfully created your rewards token account, now please approve your unstake transactions.", { id: "unstake", duration: 5000 })
      }

      // const { blockhash } = await connection.getLatestBlockhash();


      const signedTransactions = await wallet.signAllTransactions(datedUnstakeSelected);

      await Promise.all(
        (signedTransactions as Transaction[])
          .map((tx) =>
            connection.sendRawTransaction(tx.serialize(), {
              // skipPreflight: false,
              preflightCommitment: "confirmed",
            })
              .then(async (txid) => {
                toast.loading("Attempting to unstake NFTs",
                  {
                    id: "unstake",
                    duration: Infinity
                  }
                )
                // console.log("txid", txid)
                await connection.confirmTransaction(txid, "confirmed")
                toast.success("Successfully Unstaked NFTs",
                  {
                    id: "unstake",
                    duration: 5000
                  }
                )
                fetchNFTs();
                // setValidNFTHeld([...validNFTHeld, ...selectedNFTs])
              })
          ));

      // console.log("stakeTxs", stakeTxs)
    } catch (error) {
      let errorMessage = error?.message ?? error;
      // console.error("Error unstaking nft", errorMessage)
      toast.error(`Error unstaking nft ${errorMessage}`, {
        id: "unstake",
        duration: 5000
      })
    }
  };

  // Claim
  const handleClaim = async () => {
    if (!wallet.publicKey) {
      toast.error(`Please connect your wallet`, {
        id: "claim",
        duration: 5000
      })
      return;
    }

    try {
      toast.loading("Generating Claim Rewards Transactions", {
        id: "claim",
        duration: Infinity
      })
      // console.log("selectedNFTs", selectedNFTs)

      // const unstakePoolEntries = selectedNFTs.map((nft) => {
      //   return {
      //     mintId: new PublicKey(nft.mintAddress)
      //   }
      // });


      const stakedNfts = validNFTHeld.filter((nft) => nft.collectionAddress === collectionFilter && nft.isCurrentlyStaked).map((nft) => { return { mintId: new PublicKey(nft.mintAddress) } });

      let claimRewardsTxs = await claimRewards(
        connection,
        wallet,
        collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "pool-name-0.1908876937934032" : "pool-name-0.7364440881038641",
        stakedNfts,
        [new PublicKey(collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "38JuPXo9QpFFnBsvk75a3fScCQSC7f6phtidHpAtQhWr" : "HQw3xmjaPSwNVVPNjstCmj3uFXdpwfzqP9HYqnAqqUdS")],
        true
      )

      // console.log("claimRewardsTxs", claimRewardsTxs)
      // const unstakePoolEntries = await Promise.all(selectedNFTs.map(async (nft) => {
      //   const unstakeEntry = await unstake(
      //     connection,
      //     wallet,
      //     {
      //       stakePoolId: new PublicKey("EMcaKcSwm4NbWAZWQheX91kP6P6E5M7wbKHBKe8PhLrQ"),
      //       originalMintId: new PublicKey(nft.mintAddress),
      //     }
      //   )
      //   return unstakeEntry
      // }));

      const { blockhash } = await connection.getLatestBlockhash();
      const datedClaimRewardsTxs = claimRewardsTxs.map((tx) => {
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        return tx;
      });

      const userGobiATA = getAssociatedTokenAddressSync(gobiAddress, wallet.publicKey);
      // console.log("userGobiATA", userGobiATA)
      let isGobiATAOpen = (await connection.getAccountInfo(userGobiATA)) !== null;

      if (!isGobiATAOpen) {
        let createGobiATA = createAssociatedTokenAccountInstruction(
          wallet.publicKey,
          userGobiATA,
          wallet.publicKey,
          gobiAddress,
        )

        const { blockhash } = await connection.getLatestBlockhash();

        const tx = new Transaction().add(createGobiATA);
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        toast.loading("Step 1 of 2: Please create your rewards token account first", {
          id: "claim",
          duration: Infinity
        })
        await wallet.sendTransaction(tx, connection)
        toast.success("Step 2 of 2: Successfully created your rewards token account, now please approve your claim transactions.", { id: "claim", duration: 5000 })
      }

      // const { blockhash } = await connection.getLatestBlockhash();


      const signedTransactions = await wallet.signAllTransactions(datedClaimRewardsTxs);

      await Promise.all(
        (signedTransactions as Transaction[])
          .map((tx) =>
            connection.sendRawTransaction(tx.serialize(), {
              // skipPreflight: false,
              preflightCommitment: "confirmed",
            })
              .then(async (txid) => {
                toast.loading("Attempting to Claim Rewards",
                  {
                    id: "claim",
                    duration: Infinity
                  }
                )
                // console.log("txid", txid)
                await connection.confirmTransaction(txid, "confirmed")
                toast.success("Successfully Claimed Rewards",
                  {
                    id: "claim",
                    duration: 5000
                  }
                )
                fetchNFTs();
                // setValidNFTHeld([...validNFTHeld, ...selectedNFTs])
              })
          ));

      // console.log("stakeTxs", stakeTxs)
    } catch (error) {
      let errorMessage = error?.message ?? error;
      // console.error("Error unstaking nft", errorMessage)
      toast.error(`Error claiming rewards ${errorMessage}`, {
        id: "claim",
        duration: 5000
      })
    }
  };

  // const { data: stakePoolData } = useStakePoolData()

  // const refreshStakeEntries = useCallback(async () => {
  //   if (!stakePoolData) return
  //   if (!wallet?.publicKey) return

  // }, [stakePoolData.data, wallet.publicKey])

  // useEffect(() => {
  //   refreshStakeEntries().catch((e) =>
  //     console.error("Error while fetching candy machine", e)
  //   );
  // }, []);

  return (
    <>
      <Head>
        <title>Staking : Merchants of Gobi</title>
        <meta name="description" content="Merchants of Gobi Staking" />
      </Head>
      <StyledStakingPage className="stakingPage">

        <MaxWidthWrapper className="stakingPage-pageWrapper">

          <div className="stakingPage-topSection">

            <div className="stakingPage-modeSwitch">
              <CollectionSwitch />
            </div>

            <div className="stakingPage-info">
              <div className="stakingPage-infoPair">
                <div>{stakedMerchants}</div>
                <div>Merchants Staked</div>
              </div>
              <div className="stakingPage-infoPair">
                <div>{stakedMaps}</div>
                <div>Maps Staked</div>
              </div>
              <div className="stakingPage-infoPair">
                <div>{totalAccumulatedRewards}</div>
                <div>$GOBI Claimed</div>
              </div>
            </div>

          </div>

          <div className="stakingPage-intro">
            <h1>Stake your Merchants and Maps</h1>
          </div>

          <div className="stakingPage-buttons">
            {wallet.connected ? (
              <>
                <button className="stakingPage-button stakingPage-button--stakeAll" onClick={handleStake}>
                  Stake All
                </button>
                <button className="stakingPage-button stakingPage-button--unstakeAll" onClick={handleUnstake}>
                  Unstake All
                </button>
                <button className="stakingPage-button stakingPage-button--claimGobi" onClick={handleClaim}>
                  Claim {claimableRewards} $GOBI
                </button>
              </>
            ) : (
              <div>
                <WalletButton>
                  {({ connecting, connected, shortAddress, wallet }) => (
                    <>
                      {connecting ? (
                        <span>Connecting...</span>
                      ) : connected ? (
                        <>{shortAddress}</>
                      ) : (
                        <span>Connect Wallet</span>
                      )}
                    </>
                  )}
                </WalletButton>
              </div>
            )}
          </div>

          {/* Grid */}
          {validNFTHeld?.length > 0 &&
            <div className="stakingPage-grid">
              {validNFTHeld.filter((nft) => nft.collectionAddress == collectionFilter).map(nft => (
                <StakingCard nft={nft} key={nft.mintAddress} fetchNFTs={fetchNFTs} collectionFilter={collectionFilter} />
              ))}
            </div>
          }

        </MaxWidthWrapper>

      </StyledStakingPage>
    </>
  );

}


export const getStaticProps = async ({ params }) => {

  const ssh = createServerSideHelpers({
    router: appRouter,
    ctx: await createContext(),
    transformer: superJson
  });

  return {
    props: {
      trpcState: ssh.dehydrate(),
    },
    revalidate: 1
  };

};


StakingPage.getLayout = (page: ReactElement) => {
  return (
    <MainLayout >
      <WalletLayout>
        {page}
      </WalletLayout>
    </MainLayout>
  )
}


export default StakingPage;


const StyledStakingPage = styled.div`

  min-height: 100vh;
  padding: 1rem 1rem 0 1rem;

  .stakingPage-topSection{

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${color.gray(25)};

    .stakingPage-modeSwitch{

      .modeSwitch{
        margin: 0 auto;
      }

    }

    .stakingPage-info{

      display: flex;
      justify-content: space-between;
      gap: 1rem;
      width: 100%;
      margin-top: 2rem;
      padding: 0 1rem;

      .stakingPage-infoPair{

        display: flex;
        flex-direction: column;

        div:first-child{
          font-size: 1rem;
          font-weight: 750;
          text-align: center;
        }

        div:last-child{
          color: ${color.gray(50)};
          font-size: 0.875rem;
          font-weight: 300;
          text-align: center;
        }

      }

    }

  }

  .stakingPage-intro{

    max-width: 40rem;
    margin-top: 2rem;
    color: ${color.gray(90)};

    h1{
      font-size: 1.5rem;
      margin-bottom: 0.375rem;
    }

  }

  .stakingPage-buttons{

    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1.5rem;

    button{
      height: 2.25rem;
      padding: 0 2rem;
      color: black;
      font-size: 0.875rem;
      font-weight: 600;
      border-radius: 0.375rem;
      background-color: ${color.gray(80)};
      transition: background-color 0.15s ease-out;

      &:hover{
        background-color: ${color.gray(100)};
      }

    }

  }

  .stakingPage-grid{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
    grid-gap: 0.5rem;
    margin-top: 2rem;
  }
  

  @media (min-width: ${bp(2)}) {

    .stakingPage-grid{
      grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
    }

    .stakingPage-buttons{
      flex-direction: row;
      gap: 1.5rem;
    }

  }

  @media (min-width: ${bp(3)}) {

    .stakingPage-topSection{

      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 3rem;

      .stakingPage-info{

        gap: 2rem;
        width: auto;
        margin-top: 0;

        .stakingPage-infoPair{

          div:first-child{
            font-size: 1.25rem;
          }

          div:last-child{
            font-size: 1rem;
          }

        }

      }

    }

  }

  @media (min-width: ${bp(4)}) {

    padding: 1.5rem 3rem 10rem 3rem;

    .stakingPage-topSection{

      gap: 4rem;
      padding-bottom: 2rem;

      .stakingPage-info{
        gap: 3rem;
        width: auto;
        margin-top: 0;
      }

    }

    .stakingPage-grid{
      grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
      grid-gap: 0.5rem;
      margin-top: 3rem;
    }

  }

  @media (min-width: ${bp(5)}) {

    padding: 1.5rem 4rem 10rem 4rem;

    .stakingPage-pageWrapper{
      padding-left: 2rem;
      padding-right: 2rem;
    }

    .stakingPage-grid{
      grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
      grid-gap: 0.5rem;
      margin-top: 3rem;
    }

  }
  
`;